var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('welcome-conference-banner',{staticClass:"py-8",attrs:{"background-color":"#FAFAFA"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }